import React from 'react';
import Content, { options } from '@components/Content';
import { CardGridProps } from 'ech-components/src/components/CardGrid';
import { IntlShape } from 'react-intl';
import { colors } from 'ech-components/src/core/styles/theme/default';
import { ContentReference } from '~/components/Content/helpers';

const factsService = (
  data: {
    facts: [];
    title?: string;
  },
  intl: IntlShape,
) => {
  const factsProps: CardGridProps = data?.facts
    ? {
        items: data.facts.map(
          ({
            highlight,
            content,
          }: {
            highlight: string;
            content: {
              raw: string;
              references: ContentReference[];
            };
          }) => ({
            highlight,
            richtext: <Content content={content} options={options} nested />,
          }),
        ),
        title: data?.title,
        moduleName: 'Fact',
        background: true,
        backgroundColor: colors.primarySunYellow300,
        hideMoreLink: true,
        moreLinkFallback: '',
        locale: intl.locale,
      }
    : null;

  return factsProps;
};

export default factsService;
